import { Component, Inject, Input } from 'ng-metadata/core';
import './empty-state.component.scss';

/**
 * @ngdoc directive
 * @name mwEmptyState
 * @module mw.components.emptyState
 *
 * @param {string} [text] - The main text to be displayed in the empty state container.
 * @param {string} [sub-text] - The sub-text to be displayed below the main text.
 * @param {string} [icon] - The name of the icon to be displayed.
 * @param {string} [icon-size='medium'] - The size of the icon.  Supported values are 'small', 'medium', 'large'.
 *
 * @description
 * `<mw-empty-state>` is a component used to display guidance information to the user when there is no data to display.
 * Within the mw-empty-state, we have three different slots which will be transcluded into the component
 * `<mw-empty-state-text>` Will be where the main text is stored.
 * `<mw-empty-state-sub-text>` is where any underlying text will live under the main text
 * `<mw-empty-state-actions>` is where any actions should be listed such as buttons and such.
 *
 * @usage
 * <hljs hljs-language="html">
 *    <mw-empty-state icon="communication:ic_no_sim_24px" icon-size="medium">
 *      <mw-empty-state-text> TITLE </mw-empty-state-text>
 *      <mw-empty-state-sub-text> SUB TEXT </mw-empty-state-text>
 *      <mw-empty-state-actions> <md-button class="mw-button"> ACTION </md-button> </mw-empty-state-actions>
 *    </mw-empty-state>
 * </hljs>
 *
 * Transclusion service
 * Search data tables
 * Potential transclusion with span
 * Transclusions to ensure backwards compatability is good
 * //Make sure multiple use case for dialogs is alright
 */
@Component({
    selector: 'mw-empty-state',
    template: `
        <div class="mw-empty-state" layout="column" layout-align="center center">
            <ng-transclude class="mw-empty-state__span" ng-transclude-slot="mwEmptyStateSpan"> </ng-transclude>
            <md-icon class="mw-empty-state__icon" ng-if="$ctrl.icon" md-svg-icon="{{ $ctrl.icon }}" ng-class="{'mw-empty-state__icon--large': $ctrl.iconSize === 'large', 'mw-empty-state__icon--medium': $ctrl.iconSize === 'medium', 'mw-empty-state__icon--small': $ctrl.iconSize === 'small'}"></md-icon>
            <ng-transclude ng-transclude-slot="mwEmptyStateText" class="mw-empty-state__text">
                {{$ctrl.text}}
            </ng-transclude>
            <ng-transclude ng-transclude-slot="mwEmptyStateSubText" class="mw-empty-state__sub-text" ng-class="{'mw-empty-state__sub-text-visible': $ctrl.childrenIsVisible || $ctrl.subText}">
                {{$ctrl.subText}}
            </ng-transclude>
            <ng-transclude ng-transclude-slot="mwEmptyStateActions" layout="row"> </ng-transclude>
        </div>
    `,
    legacy: {
        transclude: {
            mwEmptyStateSpan: '?span',
            mwEmptyStateText: '?mwEmptyStateText',
            mwEmptyStateSubText: '?mwEmptyStateSubText',
            mwEmptyStateActions: '?mwEmptyStateActions'
        }
    }
})
export class EmptyStateComponent {
    @Input('@') icon: string;
    @Input('@') iconSize: string = 'medium';
    @Input('@') text: string;
    @Input('@') subText: string;

    childrenIsVisible: boolean

    constructor (@Inject('$transclude') private $transclude) {
        'ngInject';

        this.childrenIsVisible = $transclude.isSlotFilled('mwEmptyStateSubText');
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/empty-state/empty-state.component.ts